import { useRef, useEffect } from 'react';

/**
 * A hook to provide a reference to the value of a variable from the previous render
 *
 * @param {*} variable
 */
const usePrevious = (variable) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = variable;
    }, [variable]);
    return ref.current;
};

export default usePrevious;
